import { PaymentPlanCardTiers, PaymentPlanTier } from '@/types/schema';
import { isSelfHosted } from '@/utils/is-self-hosted';
import { capitalize } from '@/utils/stringUtils';

export const planToDisplayName = (
  plan: PaymentPlanCardTiers | PaymentPlanTier
) => {
  // All self-hosted customers should display as Enterprise plan.
  if (isSelfHosted) {
    return 'Enterprise';
  }

  switch (plan) {
    case 'applyStartup':
      return 'Startup';
    case 'applyEnterprise':
      return 'Enterprise';
    case 'no_plan':
      return 'No Plan';
    case 'free':
      return 'Developer';
    default:
      if (plan.includes('_legacy')) {
        return capitalize(plan.replace('_legacy', ''));
      }
      // look for regex for plan_v0 or plan_v1 etc where plan is the plan name
      if (/^[a-z]+_v[0-9]+$/.test(plan)) {
        return capitalize(plan.replace(/_v[0-9]+/, ''));
      }
      return capitalize(plan);
  }
};
